import styled from 'styled-components';
import colors from '../../../config/colors';

const PageTitle = styled.div`
  background: radial-gradient(50% 50% at 50% 50%, #F4D8A0 0%, #F6BF51 100%);
  position: relative;
  text-align: center;

  @media (max-width: 992px) {
    overflow: hidden;
  }

  h1 {
    font-size: 44px;
    margin: 4px 0;

    @media (max-width: 576px) {
      font-size: 30px;
    }
  }

  p {
    font-size: 20px;
    line-height: 30px;
    color: ${colors.BLACK_COLOR};
    margin: 0 0 10px;

    @media (max-width: 576px) {
      font-size: 16px;
      line-height: 26px;
    }
  }

  ul {
    background: none;
    padding: 0;

    li {
      color: ${colors.BLACK_COLOR};

      &:before,
      &:last-child {
        color: ${colors.BLACK_COLOR};
      }

      a {

        &:hover {

          svg {
            stroke: ${colors.PURPLE_COLOR};
          }
        }
      }

      svg {
        stroke: ${colors.BLACK_COLOR};
        transition: stroke 200ms ease-in-out;
      }
    }
  }
`;

const PageTitleContainer = styled.div`
  width: 100%;
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 15px;
  display: flex;
  align-items: center;
  text-align: left;
  min-height: 162px;
  display: flex;
  justify-content: center;

  @media (max-width: 1200px) {
    max-width: 1040px;
    overflow: hidden;
  }

  @media (max-width: 992px) {
    min-height: 0;
    padding: 28px 15px;
    z-index: 1;
  }
`;

const PageTitleText = styled.div`
  padding: 15px 0;

  @media (max-width: 576px) {
    padding: 0;
  }
`;

export {
  PageTitle,
  PageTitleContainer,
  PageTitleText
};

export default PageTitle;
